import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  CanMatchFn,
  Router,
  UrlTree
} from '@angular/router';

import { ExtendedRoute } from '@hdms/shared/common-types';

import { RouterHelperService } from '../..';

import { FeatureToggleService } from './feature-toggle.service';

export const canActivateWithToggle: CanActivateFn = route => inject(FeatureToggleGuard).canActivate(route);

export const canActivateChildWithToggle: CanActivateChildFn = childRoute =>
  inject(FeatureToggleGuard).canActivate(childRoute);

export const canMatchWithToggle: CanMatchFn = route => inject(FeatureToggleGuard).canLoad(route);

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleGuard {
  protected readonly router = inject(Router);
  protected readonly ftService = inject(FeatureToggleService);
  protected readonly routerHelper = inject(RouterHelperService);

  canActivate(route: ActivatedRouteSnapshot): UrlTree | boolean {
    return this.checkToggle(route as ExtendedRoute);
  }

  canLoad(route: ExtendedRoute): UrlTree | boolean {
    return this.checkToggle(route);
  }

  protected checkToggle(route: ExtendedRoute): UrlTree | boolean {
    const toggleName = route.data.toggleName;
    const isToggleEnabled = toggleName && this.ftService.getToggleById(toggleName);
    const toggleOnReroute = route.data.toggleOnReroute;
    const toggleOffReroute = route.data.toggleOffReroute;

    if (
      (isToggleEnabled && !toggleOnReroute) ||
      (!isToggleEnabled && toggleOffReroute === this.routerHelper.finalUrl)
    ) {
      return true;
    } else if ((isToggleEnabled && toggleOnReroute) || (!isToggleEnabled && toggleOffReroute)) {
      const path = toggleOnReroute || toggleOffReroute;
      return this.router.createUrlTree([path]);
    }
    return false;
  }
}
